// extracted by mini-css-extract-plugin
module.exports = {"codeAutocompletePopper":"CountryCodeSelector_codeAutocompletePopper__9PCMX","flag":"CountryCodeSelector_flag__0u5K0","lockIcon":"CountryCodeSelector_lockIcon__m4BU5"};